import { useEffect } from "react";
import { applyDisplayScale } from "@/lib/displayScale";

// Roles whose portals are mobile-first (rider/hub-operator) — never counter-scaled.
const MOBILE_PORTAL_ROLES = new Set(["pharmeasy_rider", "pharmeasy_hub_operator"]);

/**
 * Keeps the Windows display-scaling neutralizer in sync (see lib/displayScale).
 * Disabled for the rider/hub mobile portals; re-evaluates when the DPR changes
 * (e.g. moving the window between monitors at different scaling).
 */
export function useDisplayScale(user) {
  const enabled = !MOBILE_PORTAL_ROLES.has(user?.role);

  useEffect(() => {
    applyDisplayScale(enabled);
    const onChange = () => applyDisplayScale(enabled);
    window.addEventListener("resize", onChange);
    return () => {
      window.removeEventListener("resize", onChange);
      applyDisplayScale(false); // clear on unmount/disable
    };
  }, [enabled]);
}
